<template>
    <div :class="['footer', { 'footer--transparent': transparentBackground }]">
        <div class="payment-methods">
            <div class="payment-icons">
                <img src="../assets/Logos/Visa.png" alt="Visa Credit Card Logo" width="70" height="44" loading="lazy" decoding="async">
                <img src="../assets/Logos/MasterCard.png" alt="MasterCard Credit Card Logo" width="70" height="44" loading="lazy" decoding="async">
                <img src="../assets/Logos/Discover.png" alt="Discover Credit Card Logo" width="70" height="44" loading="lazy" decoding="async">
                <img src="../assets/Logos/Amex.png" alt="AMEX Credit Card Logo" width="70" height="44" loading="lazy" decoding="async">
            </div>  
            <p class="CCDisclaimer">
                We accept all major credit cards.
            </p>
        </div>
        <div class="contact-info">
            <p>Homes Roofing Co LLC</p>

            <div class="footer-locations">
                <div class="footer-location">
                    <h2>Southwest Michigan</h2>
                    <p>Niles, MI 49120</p>
                    <p><a href="tel:+12692625055">(269) 262-5055</a></p>
                    <a class="footer-fb" href="https://www.facebook.com/profile.php?id=100091999461722" target="_blank" rel="noopener">
                        <img :src="Facebook" alt="" width="18" height="18" loading="lazy" decoding="async">
                        <span>Southwest Michigan on Facebook</span>
                    </a>
                </div>
                <div class="footer-location">
                    <h2>Northern Michigan</h2>
                    <p>Gaylord, MI 49735</p>
                    <p><a href="tel:+19898583559">(989) 858-3559</a></p>
                    <a class="footer-fb" href="https://www.facebook.com/profile.php?id=61588863027649" target="_blank" rel="noopener">
                        <img :src="Facebook" alt="" width="18" height="18" loading="lazy" decoding="async">
                        <span>Northern Michigan on Facebook</span>
                    </a>
                </div>
            </div>

            <nav class="footer-links" aria-label="Footer">
                <router-link to="/">Niles Roofing</router-link>
                <router-link to="/gaylord-roof-repair">Gaylord Roofing</router-link>
                <router-link to="/storm-damage-repair">Storm Damage Help</router-link>
                <router-link to="/roof-repair">Roof Repair</router-link>
                <router-link to="/roof-replacement">Roof Replacement</router-link>
            </nav>

            <p><a href="mailto:homesroofingco@gmail.com">homesroofingco@gmail.com</a></p>


            <p class="copyright">© 2026 Homes Roofing Co LLC. All rights reserved.</p>
            <p class="site-credit">Website by <a href="https://muthdigital.com/" target="_blank" rel="noopener">Muth Digital</a></p>

        </div>
        
    </div>
</template>

<script>
export default {
    name: 'PageFooter',
    props: {
        transparentBackground: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            Facebook: require('@/assets/Logos/Facebook.png'),
        };
    },
}
</script>

<style scoped>

.payment-icons {
    display: flex;
    justify-content: space-between;

    img {
        width: 70px;
        height: auto; /* maintain aspect ratio */
        object-fit: contain; /* ensure the images fit within their box */
        border-radius: 5px; /* round the corners */
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15); /* add a shadow for depth */
        margin-right: 10px; /* add some space between the images */
    }
}

.contact-info a {
    text-decoration: none;
}


.footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-image: linear-gradient(to right, #002655, #89c2fc);
    color: #f5f5f5;
}

.footer--transparent {
    background: transparent;
    background-image: none;
}

.payment-methods {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 20px;
}

.contact-info {
    text-align: center;

    a {
        text-decoration: none;
    }
}


/* Media query for tablet and larger screens */
@media (min-width: 768px) {
    .footer {
        flex-direction: row;
        justify-content: space-around;
        display: flex;
    }

    .payment-methods {
        margin-bottom: 0;
        flex-direction: column;
    }



    .contact-info {
        text-align: left;
    }
}

   /* specific styling for Mobile */
   .contact-info {
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;

        a {
            color: #f1c40f;

            &:hover {
                text-decoration: underline;
                color: #ffffff;
            }
        }
   }
   .phone-button {
  display: inline-block;
  padding: 12px 30px;
  background-color: #8d0808;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  width: 100%;
}

.phone-button:hover {
  background-color: #0056b3;
}

.footer-locations {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin: 10px 0;
}

.footer-locations .footer-location h2 {
    margin: 0 0 4px;
    font-size: 1rem;
    color: #f1c40f;
}

.footer-locations .footer-location p {
    margin: 0;
}

.contact-info .footer-locations a.footer-fb {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    padding: 7px 12px;
    border-radius: 8px;
    background-color: #3b5998;
    color: #fff;
    font-size: 0.9rem;
    font-weight: 600;
    text-decoration: none;
    transition: background-color 0.2s ease, transform 0.2s ease;
}

.contact-info .footer-locations a.footer-fb:hover {
    background-color: #2d4373;
    transform: translateY(-1px);
}

.footer-fb:focus-visible {
    outline: 3px solid #f1c40f;
    outline-offset: 2px;
}

@media (min-width: 480px) {
    .footer-locations {
        flex-direction: row;
        justify-content: center;
        gap: 32px;
    }
}

@media (min-width: 768px) {
    .footer-locations {
        justify-content: flex-start;
    }
}


.footer-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px 18px;
    margin: 14px 0 6px;
}

.footer-links a {
    color: #f1c40f;
    font-weight: 600;
    text-decoration: none;
}

.footer-links a:hover {
    text-decoration: underline;
}

.site-credit {
    margin: 4px 0 0;
    font-size: 0.85rem;
    opacity: 0.85;
}
</style>